/* rs-set-builder.js — dein-set UX (meters, reset, cards, tracking) */
(function () {
  'use strict';
  if (window.RSSetBuilderInstalled) return;
  window.RSSetBuilderInstalled = true;

  document.documentElement.classList.add('rs-set-page');

  /* Late CSS beats boxFix <style id="rs-box-fix"> which mounts in the body */
  (function injectSetOverrides() {
    var id = 'rs-set-builder-overrides';
    var style = document.getElementById(id);
    if (!style) {
      style = document.createElement('style');
    style.id = id;
      (document.head || document.documentElement).appendChild(style);
    }
    style.textContent = [
      'html body #gbbBundle#gbbBundle .rs-card-info,',
      'html body #gbbBundle#gbbBundle.rs-bar .rs-card-info,',
      'html body #gbbBundle#gbbBundle:not(.rs-bar) .rs-card-info{',
      'display:inline-block!important;margin-top:2px;font:500 12px/1.35 Lato,Helvetica,Arial,sans-serif!important;',
      'color:#2c453c!important;text-decoration:underline!important;text-underline-offset:2px;cursor:pointer!important;}',
      'html.rs-set-page #gbbBundle .gbbProductImageContainer{aspect-ratio:1/1!important;max-height:none!important;height:auto!important;width:100%!important;background:#f3efe8!important;}',
      'html.rs-set-page #gbbBundle .gbbProductImage{object-fit:cover!important;width:100%!important;height:100%!important;}',
      'html.rs-set-page #gbbBundle .rs-card-dish{object-fit:cover!important;background:#f3efe8!important;}',
      'html.rs-set-page #gbbBundle .gbbProductTitle,html.rs-set-page #gbbBundle .gbbProductTitleOnly{font:700 18px/1.3 Lato,Helvetica,Arial,sans-serif!important;color:#2f2a26!important;}',
      'html.rs-set-page #gbbBundle .gbbProductPrice{font:700 20px/1.2 Lato,Helvetica,Arial,sans-serif!important;}',
      'html.rs-set-page #gbbBundle .gbbProductTextContainer{padding:8px 10px 4px!important;}',
      'html.rs-set-page #gbbBundle .gbbProductActionContainer{padding:4px 10px 10px!important;}',
      'html.rs-set-page #gbbBundle .gbbFooterButtonsWrapper{display:flex!important;flex-direction:column!important;',
      'align-items:stretch!important;gap:10px!important;width:100%!important;grid-template-columns:none!important;}',
      'html.rs-set-page #gbbBundle .gbbFooterNextButton{width:100%!important;}',
      'html.rs-set-page #gbbBundle .gbbEmptyProductCard{display:none!important;}',
      'html.rs-set-page #gbbBundle[data-rs-empty="1"] .gbbFooterClearItemsButtonWrapper{display:none!important;}',
      'html.rs-set-page #gbbBundle .gbbFooterProductsContainer[data-cart-items-length="0"]{overflow:visible!important;border:0!important;max-height:none!important;}',
      /* Fixed-height sidebar: status + thumbs + money + CTA always fit */
      'html body #gbbBundle#gbbBundle:not(.rs-bar) .gbbBundleFooter{',
      'max-height:calc(100vh - var(--header-height,72px) - 24px)!important;height:auto!important;',
      'overflow:hidden!important;display:flex!important;flex-direction:column!important;}',
      'html body #gbbBundle#gbbBundle .gbbFooterProductsContainer.rs-list--sr,',
      'html body #gbbBundle#gbbBundle .gbbFooterBundleInfoContainer.rs-list--sr{',
      'position:absolute!important;width:1px!important;height:1px!important;overflow:hidden!important;',
      'clip:rect(0 0 0 0)!important;white-space:nowrap!important;border:0!important;padding:0!important;margin:-1px!important;}',
      'html body #gbbBundle#gbbBundle .rs-list-more{display:none!important;}',
      /* Light grey category buttons under each grid */
      'html.rs-set-page #gbbBundle .rs-cat-switch{display:flex!important;flex-wrap:wrap!important;gap:8px 12px!important;margin:12px 0 8px!important;width:100%!important;}',
      'html.rs-set-page #gbbBundle .rs-nextcat{display:inline-flex!important;align-items:center!important;gap:6px!important;',
      'min-height:40px!important;margin:0!important;padding:8px 14px!important;border:1px solid #ddd8d0!important;border-radius:8px!important;',
      'background:#f3f1ed!important;color:#5a5a5a!important;font:600 14px/1.3 Lato,Helvetica,Arial,sans-serif!important;',
      'text-decoration:none!important;cursor:pointer!important;box-shadow:none!important;}',
      'html.rs-set-page #gbbBundle .rs-nextcat:hover{background:#ebe7e1!important;color:#2f2a26!important;}',
      'html.rs-set-page #gbbBundle .rs-nextcat--back{order:-1;}',
      'html.rs-set-page #gbbBundle .rs-nextcat--fwd{margin-left:0!important;}',
      'html.rs-set-page #gbbBundle [data-rs-pay] ul,#gbbBundle .rs-set-pay{display:flex!important;flex-direction:row!important;flex-wrap:wrap!important;justify-content:center!important;gap:6px!important;margin:2px 0 0!important;padding:0!important;list-style:none!important;}',
      'html.rs-set-page #gbbBundle [data-rs-pay] li,#gbbBundle .rs-set-pay>li{display:flex!important;list-style:none!important;margin:0!important;padding:0!important;}',
      /* Mobile: sticky footer was z-9999 over cards — ATC unreachable. Flow footer + fixed CTA. */
      '@media (max-width:749px){',
      'html body #gbbBundle#gbbBundle .gbbBundleFooter,html body #gbbBundle#gbbBundle:not(.rs-bar) .gbbBundleFooter{',
      'position:relative!important;top:auto!important;z-index:1!important;max-height:none!important;overflow:visible!important;}',
      'html body #gbbBundle#gbbBundle#gbbBundle .gbbProductsContainer{',
      'grid-template-columns:minmax(0,1fr)!important;gap:10px!important;padding-bottom:0!important;}',
      'html.rs-set-page #gbbBundle .rs-cat-switch{margin-top:10px!important;margin-bottom:calc(72px + env(safe-area-inset-bottom,0px))!important;}',
      'html.rs-set-page .rs-set-sticky,html.rs-set-page.rs-has-bar .rs-set-sticky{display:flex!important;}',
      'html body #gbbBundle#gbbBundle#gbbBundle .gbbProductItem{grid-template-rows:auto minmax(0,1fr) auto!important;}',
      '}'
    ].join('');
  })();

  /* Reposition open product modal. Never write styles from a style-attribute observer (that hung the tab). */
  var popupHardenLock = false;
  var popupHardenedFor = null;
  function hardenPopupLayout() {
    if (popupHardenLock) return;
    var modal =
      document.querySelector('.gbbModal[data-status="opened"] .gbbProductVariantModalContainer') ||
      document.querySelector('.gbbProductVariantModalContainer:not(.gbbHidden)');
    if (!modal) {
      popupHardenedFor = null;
      return;
    }
    var mainOpen = modal.closest('.gbbModal');
    if (mainOpen && mainOpen.getAttribute('data-status') !== 'opened') {
      popupHardenedFor = null;
      return;
    }
    /* Only once per open — re-running on every GBB class toggle crashed the tab. */
    if (popupHardenedFor === modal) return;
    popupHardenedFor = modal;
    popupHardenLock = true;
    try {
      var main = modal.closest('.gbbProductVariantModalMainContainer, .gbbModal');
      if (main) {
        main.style.setProperty('display', 'flex', 'important');
        main.style.setProperty('align-items', 'center', 'important');
        main.style.setProperty('justify-content', 'center', 'important');
        main.style.setProperty('inset', '0', 'important');
        main.style.setProperty('width', '100vw', 'important');
        main.style.setProperty('height', '100dvh', 'important');
        main.style.setProperty('z-index', '9999', 'important');
      }
      modal.style.setProperty('position', 'relative', 'important');
      modal.style.setProperty('left', 'auto', 'important');
      modal.style.setProperty('right', 'auto', 'important');
      modal.style.setProperty('top', 'auto', 'important');
      modal.style.setProperty('transform', 'none', 'important');
      modal.style.setProperty('visibility', 'visible', 'important');
      modal.style.setProperty('opacity', '1', 'important');
      modal.style.setProperty('z-index', '10000', 'important');
    } finally {
      popupHardenLock = false;
    }
  }
  function watchPopupLayout() {
    /* No observer — popup open already causes heavy DOM churn; harden once on open only. */
  }

  var CFG = window.RS_SET_CFG || {};
  var FREE_SHIPPING_FROM = Number(CFG.freeShippingFrom) || 39;
  var SHIPPING_COST = Number(CFG.shippingCost) || 4.99;
  var TIERS = [{ n: 3, pct: 5 }, { n: 5, pct: 10 }, { n: 8, pct: 20 }];
  var BESTSELLERS = [
    'bio-gemuesebruehe', 'bio-dunkle-sosse', 'bio-tomatensuppe-sosse',
    'rinderbruehe', 'braune-sosse', 'rahmsosse', 'gemuesewuerzer',
    'fleischwuerzer', 'kraeuterwuerzsalz'
  ];

  var META = {};
  try {
    if (window.RS_SET_META && typeof window.RS_SET_META === 'object') {
      META = window.RS_SET_META;
    } else {
    META = JSON.parse((document.getElementById('rs-set-meta') || {}).textContent || '{}');
    }
  } catch (e) { META = {}; }

  function money(v) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }).format(v);
  }
  function products(n) { return n + '\u00a0' + (n === 1 ? 'Produkt' : 'Produkte'); }
  function parsePrice(value) {
    var n = String(value || '').replace(/[^\d,.-]/g, '').replace(/\.(?=\d{3}(?:\D|$))/g, '').replace(',', '.');
    return Number.parseFloat(n) || 0;
  }
  function discountFor(count) {
    var t = TIERS.filter(function (x) { return count >= x.n; }).pop();
    return t ? t.pct : 0;
  }
  function nextTier(count) { return TIERS.find(function (x) { return count < x.n; }) || null; }
  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function tap(el) {
    if (!el) return;
    try { el.click(); }
    catch (err) {
    try { el.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window })); }
      catch (e2) {}
    }
  }
  function isProductModalOpen() {
    return Boolean(document.querySelector('.gbbModal.gbbProductVariantModalMainContainer[data-status="opened"]'));
  }
  function shieldBackdrop() {
    var main = document.querySelector('.gbbModal.gbbProductVariantModalMainContainer[data-status="opened"]');
    if (!main) return;
    main.style.setProperty('pointer-events', 'none', 'important');
    var dialog = main.querySelector('.gbbModalDialog');
    if (dialog) dialog.style.setProperty('pointer-events', 'auto', 'important');
    setTimeout(function () {
      main.style.removeProperty('pointer-events');
      if (dialog) dialog.style.removeProperty('pointer-events');
    }, 280);
  }
  function refreshPopup() {
    popupHardenedFor = null;
    hardenPopupLayout();
    try {
      document.dispatchEvent(new CustomEvent('rs:popup-open'));
      if (typeof window.RSPopupRefresh === 'function') window.RSPopupRefresh();
    } catch (err) {}
    updateCarousel();
  }
  var popupOpening = false;
  function openProductDetails(card) {
    if (!card || !window.__rsSetReady || popupOpening) return;
    popupOpening = true;
    var productId = card.getAttribute('data-product-id') || '';
    var titleEl = card.querySelector('.gbbProductTitleOnly, .gbbProductTitle');
    var title = titleEl ? titleEl.textContent.trim() : '';
    try {
      if (typeof window.RSPopupPrepare === 'function') window.RSPopupPrepare(productId, title);
    } catch (prepErr) {}

    function tryOpen() {
      try {
        var gbbOpen =
          window.gbb &&
          gbb.components &&
          gbb.components.productCard &&
          gbb.components.productCard.utility &&
          gbb.components.productCard.utility.openVariantModalForCard;
        if (typeof gbbOpen === 'function') {
          gbbOpen(card);
          if (isProductModalOpen()) return true;
        }
      } catch (gbbErr) {}
      var opener =
        card.querySelector('.gbbProductImage') ||
        card.querySelector('.gbbProductOverlay') ||
        card.querySelector('.gbbProductImageContainer');
      tap(opener);
      return isProductModalOpen();
    }

    /* After the user click ends — same-event backdrop close is what caused multi-click. */
    setTimeout(function () {
      tryOpen();
      shieldBackdrop();
      var tries = 0;
      (function waitReady() {
        if (isProductModalOpen()) {
          shieldBackdrop();
          refreshPopup();
          setTimeout(refreshPopup, 80);
          setTimeout(function () { popupOpening = false; }, 350);
          return;
        }
        tries += 1;
        if (tries === 4 || tries === 8) tryOpen();
        if (tries < 16) setTimeout(waitReady, 50);
        else popupOpening = false;
      })();
    }, 10);
  }

  /* Own carousel control — GBB arrows sit under our slide layer (z-index). */
  function stepCarousel(main, dir) {
    if (!main) return;
    var slides = Array.prototype.slice.call(main.querySelectorAll('.gbbCarouselSlide'));
    if (slides.length < 2) return;
    var index = Math.max(0, slides.findIndex(function (slide) { return !slide.classList.contains('gbbHidden'); }));
    var next = Math.max(0, Math.min(slides.length - 1, index + dir));
    if (next === index) return;
    slides.forEach(function (slide, i) {
      slide.classList.toggle('gbbHidden', i !== next);
    });
    var counter = main.querySelector('.rs-carousel-count');
    if (counter) counter.textContent = (next + 1) + ' / ' + slides.length;
    var prev = main.querySelector('.gbbCarouselPrev');
    var nxt = main.querySelector('.gbbCarouselNext');
    if (prev) {
      prev.style.opacity = next <= 0 ? '0.25' : '1';
      prev.style.pointerEvents = next <= 0 ? 'none' : 'auto';
    }
    if (nxt) {
      nxt.style.opacity = next >= slides.length - 1 ? '0.25' : '1';
      nxt.style.pointerEvents = next >= slides.length - 1 ? 'none' : 'auto';
    }
  }

  function norm(s) {
    return String(s || '').toLowerCase()
      .replace(/&amp;/g, '&')
      .replace(/\u00e4/g, 'ae').replace(/\u00f6/g, 'oe').replace(/\u00fc/g, 'ue').replace(/\u00df/g, 'ss')
      .replace(/[^a-z0-9]+/g, ' ').trim();
  }

  /* ---------- clear / modal copy ---------- */
  function patchClearLanguage() {
    try {
      var lang = window.gbbExt && window.gbbExt.settings && window.gbbExt.settings.languageData && window.gbbExt.settings.languageData.modals && window.gbbExt.settings.languageData.modals.clearCart;
      if (!lang) return;
      if (lang.title) lang.title.value = 'Set zurücksetzen?';
      if (lang.description) lang.description.value = 'Dein Set wird geleert. Andere Artikel im Warenkorb bleiben erhalten.';
      if (lang.confirmButtonText) lang.confirmButtonText.value = 'Set leeren';
      if (lang.triggerButtonText) lang.triggerButtonText.value = 'Set zurücksetzen';
    } catch (e) {}
    document.querySelectorAll('.gbbFooterClearItemsContent').forEach(function (el) {
      if (el.textContent.trim() !== 'Set zurücksetzen') el.textContent = 'Set zurücksetzen';
    });
  }
  if (!window.__rsClearGuard) {
    window.__rsClearGuard = true;
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (/\/cart\/clear(?:\.js)?/i.test(url)) {
        try { if (window.gbb && window.gbb.sdk && window.gbb.sdk.f) window.gbb.sdk.f.clearCartItems(); } catch (e) {}
        return Promise.resolve(new Response('{}', { status: 200, headers: { 'Content-Type': 'application/json' } }));
      }
      var p = origFetch.apply(this, arguments);
      /* EBB adds the set and redirects to checkout itself. Forcing /checkout on a timer here
         raced EBB's cart sync: checkout opened with an incomplete set, EBB auto-removed it
         ("component variant deleted after ATC") and shoppers landed on the homepage with an empty cart. */
      return p;
    };
  }

  /* ---------- purchase tracking ---------- */
  function boxCount() {
    return Array.prototype.slice.call(document.querySelectorAll(
      '#gbbBundle .gbbFooterProductsContainer .gbbFooterProductWrapper[data-product-id]'
    )).reduce(function (sum, row) {
      var q = parseInt((row.querySelector('.gbbFooterProductQuantity') || {}).textContent || '1', 10);
      if (isNaN(q)) q = parseInt(String((row.querySelector('.gbbFooterProductQuantity') || {}).textContent || '').match(/\d+/) || '1', 10) || 1;
      return sum + (q || 1);
    }, 0);
  }
  function stampPurchase() {
    var count = boxCount();
    var reached = TIERS.filter(function (t) { return count >= t.n; }).pop() || null;
    var totalEl = document.querySelector('#gbbBundle .bundleSummaryTotalValue, #gbbBundle .gbbFooterDiscountedTotalValue');
    fetch('/cart/update.js', {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        attributes: {
          _rs_set: '1',
          _rs_set_count: String(count),
          _rs_set_tier: reached ? String(reached.n) : '',
          _rs_set_discount: reached ? String(reached.pct) : '',
          _rs_set_total: String(parsePrice(totalEl && totalEl.textContent) || ''),
          _rs_source: 'dein-set',
          _rs_offer: 'builder',
          _rs_spice_eligible: '1',
          _rs_set_atc_at: new Date().toISOString()
        }
      })
    }).catch(function () {});
  }
  /* Set attributes once the shopper reaches checkout-bound state: written after EBB's own cart
     update settles (cart:updated / page hide), never in parallel with it. */
  var rsStamped = false;
  function stampOnce() {
    if (rsStamped || boxCount() === 0) return;
    rsStamped = true;
    stampPurchase();
  }
  window.addEventListener('pagehide', stampOnce);

  /* ---------- state / simulation ---------- */
  function unitPriceCents(id) {
    var key = String(id || '').split('/').pop();
    var found = 0;
    Object.keys(META).some(function (h) {
      if (String(META[h].id) === key && META[h].price) {
        found = META[h].price;
        return true;
      }
      return false;
    });
    return found;
  }
  function round2(v) { return Math.round(v * 100) / 100; }
  function discUnit(unit, pct) {
    return round2(unit * (1 - pct / 100));
  }

  function readSet() {
    var rows = Array.prototype.slice.call(document.querySelectorAll(
      '#gbbBundle .gbbFooterProductsContainer .gbbFooterProductWrapper[data-product-id]'
    ));
    var sdkItems = null;
    try {
      if (window.gbb && gbb.sdk && gbb.sdk.f && gbb.sdk.f.getCartItems) {
        sdkItems = gbb.sdk.f.getCartItems() || [];
      }
    } catch (e) { sdkItems = null; }
    var items = rows.map(function (row) {
      var qtyText = (row.querySelector('.gbbFooterProductQuantity') || {}).textContent || '1';
      var qty = parseInt(String(qtyText).match(/\d+/) || '1', 10) || 1;
      var id = row.getAttribute('data-product-id');
      var rem = row.querySelector('.gbbFooterProductRemoveButton');
      var uniqueKey = (rem && rem.getAttribute('data-unique-key')) || '';
      var cents = unitPriceCents(id);
      var price = cents > 0 ? cents / 100 : parsePrice((row.querySelector('.gbbFooterProductPrice') || {}).textContent);
      var imgEl = row.querySelector('.gbbFooterProductImage, img');
      if (uniqueKey && sdkItems) {
        for (var i = 0; i < sdkItems.length; i++) {
          var c = sdkItems[i];
          if (c.properties && c.properties._uniqueGbbSdkItemKey === uniqueKey && c.quantity > 0) {
            qty = c.quantity;
            break;
          }
        }
      }
      return {
        id: id,
        uniqueKey: uniqueKey,
        title: ((row.querySelector('.gbbFooterProductTitle') || {}).textContent || '').trim(),
        qty: qty,
        price: price,
        img: (imgEl && (imgEl.currentSrc || imgEl.src)) || ''
      };
    });
    /* If footer DOM empty but SDK has lines, build from SDK. */
    if (!items.length && sdkItems && sdkItems.length) {
      items = sdkItems.map(function (c) {
        var id = String(c.product_id || '');
        var cents = unitPriceCents(id);
        var price = cents > 0 ? cents / 100 : (Number(c.price) > 100 ? Number(c.price) / 100 : Number(c.price) || 0);
        return {
          id: id,
          uniqueKey: (c.properties && c.properties._uniqueGbbSdkItemKey) || '',
          title: c.title || c.product_title || '',
          qty: Number(c.quantity) || 1,
          price: price,
          img: c.image || c.originalSrc || ''
        };
      }).filter(function (it) { return it.uniqueKey; });
    }
    var count = items.reduce(function (s, i) { return s + i.qty; }, 0);
    var sub = round2(items.reduce(function (s, i) { return s + i.price * i.qty; }, 0));
    var pct = discountFor(count);
    var discounted = round2(items.reduce(function (s, i) {
      return s + discUnit(i.price, pct) * i.qty;
    }, 0));
    var shipping = count === 0 ? 0 : (discounted >= FREE_SHIPPING_FROM ? 0 : SHIPPING_COST);
    return {
      items: items, count: count, sub: sub, pct: pct, discounted: discounted, shipping: shipping,
      total: round2(discounted + shipping),
      freeShip: discounted >= FREE_SHIPPING_FROM && count > 0,
      shipGap: round2(Math.max(0, FREE_SHIPPING_FROM - discounted)),
      next: nextTier(count)
    };
  }
  window.RSSetRead = readSet;

  function cheapestBuilderPrice() {
    var min = Infinity;
    Object.keys(META).forEach(function (h) {
      var c = Number(META[h] && META[h].price) || 0;
      if (c > 0 && c < min) min = c;
    });
    return min === Infinity ? 0 : min / 100;
  }

  function simulateAdd(state, unitPrice) {
    var count = state.count + 1;
    var pct = discountFor(count);
    var discounted = round2(state.items.reduce(function (s, i) {
      return s + discUnit(i.price, pct) * i.qty;
    }, 0) + discUnit(unitPrice, pct));
    var shipping = discounted >= FREE_SHIPPING_FROM ? 0 : SHIPPING_COST;
    return {
      count: count, pct: pct, discounted: discounted, shipping: shipping,
      total: round2(discounted + shipping),
      freeShip: discounted >= FREE_SHIPPING_FROM,
      unlockedTier: !!(state.next && count >= state.next.n),
      unlockedShip: !state.freeShip && discounted >= FREE_SHIPPING_FROM,
      delta: round2((discounted + shipping) - state.total)
    };
  }

  function cheapestUnlocksShip(state) {
    var cheap = cheapestBuilderPrice();
    if (!(cheap > 0)) return false;
    try {
      return !!simulateAdd(state, cheap).unlockedShip;
    } catch (e) {
      return false;
    }
  }

  function checklistTitle(state) {
    if (!state.count) {
      return 'Ab 3 Produkten sparst du −5 %';
    }
    if (state.freeShip && !state.next) {
      return '✓ Bester Preis: −' + state.pct + ' % + Versand gratis';
    }
    var next = state.next;
    var toShip = !state.freeShip && state.shipGap > 0;
    var toTier = next && (next.n - state.count) > 0;
    if (toTier) {
      var left = next.n - state.count;
      if (left === 1) {
        if (toShip && cheapestUnlocksShip(state)) {
          return 'Noch 1 Produkt bis −' + next.pct + ' % + Versand gratis';
        }
        return 'Noch 1 Produkt bis −' + next.pct + ' %';
      }
      return 'Noch ' + products(left) + ' bis −' + next.pct + ' %';
    }
    if (toShip) {
      return 'Noch ' + money(state.shipGap) + ' bis Versand gratis';
    }
    return '✓ Bester Preis: −' + state.pct + ' % + Versand gratis';
  }

  function unitBesideFromDisplay(info, displayEuro) {
    if (!(info.unitPriceCents > 0 && info.priceCents > 0 && displayEuro > 0)) return '';
    var scaled = round2((info.unitPriceCents / 100) * (displayEuro / (info.priceCents / 100)));
    return money(scaled) + '/' + (info.unitRef || 'kg');
  }

  function ensureProgress(bundle) {
    var host = bundle.querySelector('.rs-progress');
    if (host && host.querySelector('[data-checklist]')) {
      var msgGone = host.querySelector('.rs-progress__msg');
      if (msgGone) msgGone.remove();
      return host;
    }
    if (!host) {
    host = document.createElement('div');
    host.className = 'rs-progress';
    }
    host.innerHTML =
      '<div class="rs-progress__check" data-checklist>' +
        '<p class="rs-progress__check-title" data-check-title></p>' +
        '<ul class="rs-progress__check-list" data-check-list></ul>' +
      '</div>';
    var footer = bundle.querySelector('.gbbBundleFooter');
    var titleBlock = footer && footer.querySelector('.gbbFooterBundleInfoContainer');
    if (!host.parentElement) {
    if (titleBlock && titleBlock.parentElement) titleBlock.parentElement.insertBefore(host, titleBlock);
    else if (footer) footer.prepend(host);
    }
    return host;
  }

  function renderProgress(bundle) {
    var host = ensureProgress(bundle);
    var state = readSet();

    var titleEl = host.querySelector('[data-check-title]');
    if (titleEl) {
      var title = checklistTitle(state);
      if (titleEl.dataset.rs !== title) {
        titleEl.dataset.rs = title;
        titleEl.textContent = title;
      }
    }

    var list = host.querySelector('[data-check-list]');
    if (list) {
      /* Keep checklist visible at top tier+ items — collapsing looked like a missing panel. */
      list.hidden = false;
      host.classList.remove('rs-progress--collapsed');
      var rows = TIERS.map(function (t) {
        var done = state.count >= t.n;
        return '<li class="' + (done ? 'is-done' : 'is-todo') + '">' +
          '<span class="rs-progress__mark" aria-hidden="true">' + (done ? '✓' : '○') + '</span>' +
          '<span class="rs-progress__left">' + t.n + ' Produkte</span>' +
          '<span class="rs-progress__right">' + t.pct + '&nbsp;% Rabatt</span>' +
          '</li>';
      });
      var shipDone = state.freeShip;
      rows.push(
        '<li class="' + (shipDone ? 'is-done' : 'is-todo') + '">' +
          '<span class="rs-progress__mark" aria-hidden="true">' + (shipDone ? '✓' : '○') + '</span>' +
          '<span class="rs-progress__left">ab 39&nbsp;€</span>' +
          '<span class="rs-progress__right">Versand gratis</span>' +
        '</li>'
      );
      var html = rows.join('');
      if (list.dataset.rs !== html) {
        list.dataset.rs = html;
        list.innerHTML = html;
      }
    }

    host.querySelectorAll('[data-presets], .rs-progress__presets, .rs-progress__msg').forEach(function (el) { el.remove(); });

    syncSummary(bundle, state);
    renderContents(bundle, state);
    renderStickyBar(state);
  }

  var THUMB_SLOTS = 12;

  function syncNativeList(bundle) {
    var itemsHost = bundle.querySelector('.gbbFooterBundleItemsContainer');
    if (!itemsHost) return;
    var gbbList = itemsHost.querySelector('.gbbFooterProductsContainer');
    var gbbInfo = bundle.querySelector('.gbbFooterBundleInfoContainer');
    if (gbbInfo) gbbInfo.classList.add('rs-list--sr');
    if (!gbbList) return;
    var open = bundle.classList.contains('rs-list-open') && boxCount() > 0;
    if (open) gbbList.classList.remove('rs-list--sr');
    else gbbList.classList.add('rs-list--sr');
  }

  function setListOpen(bundle, open) {
    if (!bundle) return;
    if (open && boxCount() > 0) bundle.classList.add('rs-list-open');
    else bundle.classList.remove('rs-list-open');
    syncNativeList(bundle);
    var btn = bundle.querySelector('.rs-contents [data-rs-list-btn]');
    if (btn) btn.textContent = bundle.classList.contains('rs-list-open') ? 'Liste schließen' : 'Liste ansehen';
  }

  function toggleList(bundle) {
    if (!bundle) return;
    setListOpen(bundle, !bundle.classList.contains('rs-list-open'));
  }

  function ensureContents(bundle) {
    var itemsHost = bundle.querySelector('.gbbFooterBundleItemsContainer');
    if (!itemsHost) return null;
    var panel = itemsHost.querySelector('.rs-contents');
    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'rs-contents';
      panel.innerHTML =
        '<div class="rs-contents__head">' +
          '<p class="rs-contents__title" data-rs-contents-title>Dein Set</p>' +
        '</div>' +
        '<div class="rs-thumbs" data-rs-thumbs></div>' +
        '<p class="rs-contents__empty" data-rs-contents-empty hidden></p>' +
        '<button type="button" class="rs-contents__list-btn" data-rs-list-btn>Liste ansehen</button>';
      itemsHost.insertBefore(panel, itemsHost.firstChild);
      panel.querySelector('[data-rs-list-btn]').addEventListener('click', function () {
        toggleList(bundle);
      });
      panel.addEventListener('click', function (e) {
        var thumb = e.target.closest('[data-rs-thumb]');
        if (!thumb) return;
        focusProductCard(thumb.getAttribute('data-rs-thumb'));
      });
    }
    syncNativeList(bundle);
    var emptyOld = itemsHost.querySelector('.rs-set-empty');
    if (emptyOld) emptyOld.hidden = true;
    return panel;
  }

  function renderContents(bundle, state) {
    if (!state) state = readSet();
    var panel = ensureContents(bundle);
    if (!panel) return;
    var titleEl = panel.querySelector('[data-rs-contents-title]');
    var emptyEl = panel.querySelector('[data-rs-contents-empty]');
    var thumbs = panel.querySelector('[data-rs-thumbs]');
    var listBtn = panel.querySelector('[data-rs-list-btn]');
    var empty = state.count === 0;

    if (empty) setListOpen(bundle, false);

    if (titleEl) {
      var t = empty ? 'Dein Set' : ('Dein Set · ' + state.count + ' Produkte');
      if (titleEl.dataset.rs !== t) {
        titleEl.dataset.rs = t;
        titleEl.textContent = t;
      }
    }
    if (emptyEl) {
      emptyEl.hidden = !empty;
      emptyEl.textContent = 'Noch leer. Tippe auf „+ Zum Set“.';
    }
    if (listBtn) {
      listBtn.hidden = empty;
      listBtn.textContent = bundle.classList.contains('rs-list-open') ? 'Liste schließen' : 'Liste ansehen';
    }
    syncNativeList(bundle);
    if (!thumbs) return;

    if (empty) {
      thumbs.innerHTML = '';
      thumbs.hidden = true;
      return;
    }
    thumbs.hidden = false;
    var lines = state.items.slice();
    var overflow = Math.max(0, lines.length - (THUMB_SLOTS - (lines.length > THUMB_SLOTS ? 1 : 0)));
    var show = overflow > 0 ? lines.slice(0, THUMB_SLOTS - 1) : lines.slice(0, THUMB_SLOTS);
    var html = show.map(function (item) {
      var src = item.img || '';
      return '<button type="button" class="rs-thumb" data-rs-thumb="' + item.id + '" title="' +
        String(item.title || '').replace(/"/g, '&quot;') + '">' +
        (src ? '<img src="' + src + '" alt="">' : '<span class="rs-thumb__ph"></span>') +
        '<span class="rs-thumb__qty">' + item.qty + '</span>' +
              '</button>';
          }).join('');
    if (overflow > 0) {
      html += '<button type="button" class="rs-thumb rs-thumb--more" data-rs-list-open>+' + overflow + '</button>';
    }
    if (thumbs.dataset.rs !== html) {
      thumbs.dataset.rs = html;
      thumbs.innerHTML = html;
      var more = thumbs.querySelector('[data-rs-list-open]');
      if (more) more.addEventListener('click', function () { setListOpen(bundle, true); });
    }
  }

  function focusProductCard(productId) {
    if (!productId) return;
    var card = document.querySelector('#gbbBundle .gbbProductItem[data-product-id="' + productId + '"]');
    if (!card) {
      var catId = findCategoryForProduct(productId);
      if (catId) {
        var tab = document.querySelector('#gbbBundle .gbbCategoryTabContainer[data-category-id="' + catId + '"]');
        if (tab) tab.click();
        setTimeout(function () { focusProductCard(productId); }, 400);
      }
      return;
    }
    card.scrollIntoView({ behavior: 'smooth', block: 'center' });
    card.classList.add('rs-card--flash');
    setTimeout(function () { card.classList.remove('rs-card--flash'); }, 1200);
  }

  function findCategoryForProduct(productId) {
    try {
      var cats = window.gbb.sdk.category.f.getAll() || [];
      for (var i = 0; i < cats.length; i++) {
        var map = cats[i].productsDataMap || {};
        if (Object.keys(map).some(function (k) {
          return String(map[k].productId || map[k].id || k).split('/').pop() === String(productId);
        })) return cats[i].categoryId;
      }
    } catch (e) {}
    return null;
  }

  function teardownAllPage(bundle) {
    if (!bundle) return;
    bundle.classList.remove('rs-all-page');
    var host = document.getElementById('rs-all-cats');
    if (host) host.remove();
    delete bundle.dataset.rsJumps;
  }


  function renderStickyBar(state) {
    var bar = document.getElementById('rs-set-sticky');
    if (!bar) {
      bar = document.createElement('div');
      bar.id = 'rs-set-sticky';
      bar.className = 'rs-set-sticky';
      bar.innerHTML =
        '<button type="button" class="rs-set-sticky__info" data-rs-sticky-open>' +
          '<span class="rs-set-sticky__msg" data-rs-sticky-msg></span>' +
          '<span class="rs-set-sticky__meta" data-rs-sticky-meta></span>' +
        '</button>' +
        '<button type="button" class="rs-set-sticky__cta" data-rs-sticky-atc>Zur Kasse</button>';
      document.body.appendChild(bar);
      bar.addEventListener('click', function (e) {
        if (e.target.closest('[data-rs-sticky-atc]')) {
          var atc = document.querySelector('#gbbBundle .gbbFooterNextButton');
          if (atc && !atc.classList.contains('rs-cta--disabled')) atc.click();
          return;
        }
        if (e.target.closest('[data-rs-sticky-open]')) {
          var b = document.getElementById('gbbBundle');
          setListOpen(b, true);
          var list = b && b.querySelector('.gbbFooterProductsContainer');
          if (list) list.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    }
    bar.hidden = !state.count;
    var msg = bar.querySelector('[data-rs-sticky-msg]');
    var meta = bar.querySelector('[data-rs-sticky-meta]');
    var shortTitle = checklistTitle(state).replace(/^✓\s*/, '');
    if (msg && msg.dataset.rs !== shortTitle) {
      msg.dataset.rs = shortTitle;
      msg.textContent = shortTitle;
    }
    var metaText = state.count + ' Produkte · ' + money(state.total);
    if (meta && meta.dataset.rs !== metaText) {
      meta.dataset.rs = metaText;
      meta.textContent = metaText;
    }
  }


  function ensureReceiptSummary(bundle) {
    var summary = bundle.querySelector('.bundleOrderSummary');
    if (!summary) return null;
    if (summary.querySelector('.bundleSummaryDiscountRow') && summary.querySelector('.bundleSummaryProductsValue')) {
      return summary;
    }
    summary.innerHTML =
      '<div class="bundleSummaryRow bundleSummaryProducts">' +
        '<div class="bundleSummaryLabel"><span>Produkte</span></div>' +
        '<div class="bundleSummaryValue"><span class="bundleSummaryProductsValue"></span></div>' +
      '</div>' +
      '<div class="bundleSummaryRow bundleSummaryDiscountRow">' +
        '<div class="bundleSummaryLabel"><span class="bundleSummaryDiscountLabel">Setrabatt</span></div>' +
        '<div class="bundleSummaryValue"><span class="bundleSummaryDiscountAmount"></span></div>' +
      '</div>' +
      '<div class="bundleSummaryRow bundleSummaryShipping">' +
        '<div class="bundleSummaryLabel"><span>Versand</span></div>' +
        '<div class="bundleSummaryValue"><span class="bundleSummaryShippingValue"></span></div>' +
      '</div>' +
      '<div class="bundleSummaryRow bundleSummaryTotal">' +
        '<div class="bundleSummaryLabel">Gesamt</div>' +
        '<div class="bundleSummaryValue"><span class="bundleSummaryTotalValue"></span></div>' +
      '</div>';
    return summary;
  }

  function syncSummary(bundle, state) {
    if (!state) state = readSet();
    ensureReceiptSummary(bundle);

    var productsRow = bundle.querySelector('.bundleSummaryProducts');
    if (productsRow) productsRow.style.display = state.count ? '' : 'none';
    var productsVal = bundle.querySelector('.bundleSummaryProductsValue');
    if (productsVal) productsVal.textContent = money(state.sub);
    var productsLabel = bundle.querySelector('.bundleSummaryProducts .bundleSummaryLabel span');
    if (productsLabel) productsLabel.textContent = 'Produkte (' + state.count + ')';

    var saving = Math.max(0, state.sub - state.discounted);
    var discRow = bundle.querySelector('.bundleSummaryDiscountRow');
    if (discRow) {
      discRow.style.display = saving > 0 ? '' : 'none';
      var discLabel = bundle.querySelector('.bundleSummaryDiscountLabel');
      if (discLabel) discLabel.textContent = state.pct > 0 ? ('Setrabatt −' + state.pct + ' %') : 'Setrabatt';
      var discAmt = bundle.querySelector('.bundleSummaryDiscountAmount');
      if (discAmt) discAmt.textContent = '−' + money(saving);
    }
    var oldSavings = bundle.querySelector('.bundleSummarySavings');
    if (oldSavings) oldSavings.style.display = 'none';

    var shipVal = bundle.querySelector('.bundleSummaryShippingValue');
    if (shipVal) {
      var shipText = state.count === 0 ? money(SHIPPING_COST) : (state.freeShip ? 'Kostenlos' : money(state.shipping));
      shipVal.textContent = shipText;
      shipVal.dataset.free = String(!!state.freeShip);
      shipVal.dataset.rs = shipText;
    }
    var totalVal = bundle.querySelector('.bundleSummaryTotalValue');
    if (totalVal) {
      var totalText = state.count ? money(state.total) : money(0);
      totalVal.textContent = totalText;
      totalVal.dataset.rs = totalText;
    }
  }

  function clickCardQty(productId, delta) {
    if (!productId || !delta) return false;
    var card = document.querySelector('#gbbBundle .gbbProductItem[data-product-id="' + productId + '"]');
    if (!card) return false;
    var sel = delta > 0
      ? '.gbbQuantityStepperAddButton, .gbbProductAddButton'
      : '.gbbQuantityStepperRemoveButton';
    var btn = card.querySelector(sel);
    if (!btn) return false;
    btn.click();
    return true;
  }

  function ensureFooterSteppers(bundle) {
    if (!window.__rsFooterStepBound) {
      window.__rsFooterStepBound = true;
      document.addEventListener('click', function (e) {
        var t = e.target && e.target.closest && e.target.closest('[data-rs-footer-delta]');
        if (!t || !t.closest('#gbbBundle .gbbFooterProductsContainer')) return;
        e.preventDefault();
        e.stopPropagation();
        var row = t.closest('.gbbFooterProductWrapper');
        if (!row) return;
        var delta = Number(t.getAttribute('data-rs-footer-delta')) || 0;
        var pid = row.getAttribute('data-product-id');
        var remBtn = row.querySelector('.gbbFooterProductRemoveButton');
        var qty = parseInt(remBtn && remBtn.getAttribute('data-line-quantity'), 10);
        if (!(qty > 0)) {
          var qtyEl = row.querySelector('.gbbFooterProductQuantity, .rs-footer-step__qty');
          qty = parseInt(String((qtyEl && qtyEl.textContent) || '1').match(/\d+/) || '1', 10) || 1;
        }
        if (delta < 0 && qty <= 1) {
          if (remBtn) remBtn.click();
          return;
        }
        if (!clickCardQty(pid, delta)) {
          /* Card not on current tab — bump via SDK once. */
          var key = remBtn && remBtn.getAttribute('data-unique-key');
          var f = window.gbb && gbb.sdk && gbb.sdk.f;
          if (key && f && typeof f.updateCartItem === 'function') {
            f.updateCartItem(key, { quantity: Math.max(0, qty + delta) });
          }
        }
      }, true);
    }
    bundle.querySelectorAll('.gbbFooterProductWrapper[data-product-id]').forEach(function (row) {
      var action = row.querySelector('.gbbFooterProductActionContainer');
      if (!action) return;
      var qtyEl = row.querySelector('.gbbFooterProductQuantity');
      var qty = parseInt(String((qtyEl && qtyEl.textContent) || '1').match(/\d+/) || '1', 10) || 1;
      var step = row.querySelector('.rs-footer-step');
      if (!step) {
        step = document.createElement('div');
        step.className = 'rs-footer-step';
        step.setAttribute('role', 'group');
        step.setAttribute('aria-label', 'Menge');
        step.innerHTML =
          '<button type="button" class="rs-footer-step__btn" data-rs-footer-delta="-1" aria-label="Weniger">−</button>' +
          '<span class="rs-footer-step__qty">1</span>' +
          '<button type="button" class="rs-footer-step__btn" data-rs-footer-delta="1" aria-label="Mehr">+</button>';
        action.insertBefore(step, action.firstChild);
      }
      var label = step.querySelector('.rs-footer-step__qty');
      if (label) label.textContent = String(qty);
    });
  }

  function enrichFooterPrices(bundle) {
    var pct = discountFor(boxCount());
    var list = bundle.querySelector('.gbbFooterProductsContainer');
    if (list) {
      list.classList.remove('rs-list--overflow');
      list.style.maxHeight = 'none';
      list.style.overflow = 'visible';
      list.style.height = 'auto';
      /* Kill leftover scroll-hint nodes from older builds */
      bundle.querySelectorAll('.rs-list-more').forEach(function (el) { el.remove(); });
    }
    bundle.querySelectorAll('.gbbFooterProductWrapper[data-product-id]').forEach(function (row) {
      var priceEl = row.querySelector('.gbbFooterProductPrice');
      if (!priceEl) return;
      var qtyEl = row.querySelector('.gbbFooterProductQuantity');
      var qtyText = (qtyEl && qtyEl.textContent) || priceEl.dataset.rsQty || '1';
      var qty = parseInt(String(qtyText).match(/\d+/) || '1', 10) || 1;
      var info = metaFor(row);
      var base = info.priceCents > 0 ? info.priceCents / 100 : Number(priceEl.dataset.rsBase) || 0;
      if (!(base > 0)) return;
      priceEl.dataset.rsBase = String(base);
      priceEl.dataset.rsQty = String(qty);
      var unit = pct > 0 ? discUnit(base, pct) : base;
      var line = round2(unit * qty);
      var label = qty + '|' + unit + '|' + line + '|' + pct;
      if (priceEl.dataset.rsPrice !== label) {
        priceEl.dataset.rsPrice = label;
        if (qty >= 2) {
          priceEl.style.display = '';
          priceEl.textContent = qty + ' × ' + money(unit);
        } else {
          priceEl.textContent = '';
          priceEl.style.display = 'none';
        }
      }
      var priceBox = row.querySelector('.gbbFooterProductPriceContainer');
      if (priceBox) priceBox.style.display = qty >= 2 ? '' : 'none';
      var totalEl = row.querySelector('.rs-line-total');
      if (!totalEl) {
        totalEl = document.createElement('span');
        totalEl.className = 'rs-line-total';
        var action = row.querySelector('.gbbFooterProductActionContainer');
        if (action) row.insertBefore(totalEl, action);
        else row.appendChild(totalEl);
      }
      if (totalEl.dataset.rs !== String(line)) {
        totalEl.dataset.rs = String(line);
        totalEl.textContent = money(line);
      }
      if (qtyEl) qtyEl.style.display = 'none';
    });
    ensureFooterSteppers(bundle);
  }

  /* ---------- tier fill ---------- */
  function cachedProducts() {
    try { return (window.gbbSdkHelpers && window.gbbSdkHelpers.state && window.gbbSdkHelpers.state.cachedProductsData) || {}; }
    catch (e) { return {}; }
  }
  function catalogByHandle() {
    var byHandle = {};
    try {
      var cats = (window.gbb && window.gbb.sdk && window.gbb.sdk.category && window.gbb.sdk.category.f && window.gbb.sdk.category.f.getAll)
        ? window.gbb.sdk.category.f.getAll()
        : [];
      cats.forEach(function (c) {
        var map = c.productsDataMap || {};
        Object.keys(map).forEach(function (id) {
          var prod = map[id];
          if (!prod || !prod.handle) return;
          var v = prod.variants && prod.variants[0];
          var variantId = v && (v.variantId || v.id || v.variant_id);
          if (!variantId) return;
          byHandle[prod.handle] = {
            handle: prod.handle,
            categoryId: c.categoryId,
            stepId: c.stepId,
            variantId: Number(variantId)
          };
        });
      });
    } catch (e) {}
    return byHandle;
  }

  function fillHandles(handles) {
    var bar = document.querySelector('#gbbBundle .rs-progress');
    if (bar) bar.classList.add('is-busy');
    try {
      try { if (window.gbb && window.gbb.sdk && window.gbb.sdk.f) window.gbb.sdk.f.clearCartItems(); } catch (e) {}
      var catalog = catalogByHandle();
      var add = window.gbb && window.gbb.sdk && window.gbb.sdk.f && window.gbb.sdk.f.addProductToBundle;
      if (!add) {
        console.warn('[rs-set] GBB addProductToBundle unavailable');
        return;
      }
      handles.forEach(function (handle) {
        var t = catalog[handle];
        if (!t) return;
        try {
          add({
            categoryId: t.categoryId,
            variantId: t.variantId,
            quantity: 1,
            stepId: t.stepId,
            showToast: false
          });
        } catch (err) {}
      });
    } finally {
      if (bar) bar.classList.remove('is-busy');
      paint();
    }
  }

  /* ---------- cards ---------- */
  function metaFor(card) {
    var id = String(card.getAttribute('data-product-id') || '').split('/').pop();
    var cached = cachedProducts();
    var handle = null, tags = [], img2 = null;
    Object.keys(cached).forEach(function (k) {
      var p = cached[k];
      if (!p) return;
      if (String(p.productId || p.id || k).split('/').pop() === id) {
        handle = p.handle;
        tags = p.tags || [];
        img2 = (p.images && p.images[1]) || null;
      }
    });
    var m = {};
    var metaHandle = handle || '';
    if (handle && META[handle]) {
      m = META[handle];
      metaHandle = handle;
    } else {
      Object.keys(META).some(function (h) {
        if (String(META[h].id) === id) {
          m = META[h];
          metaHandle = h;
          return true;
        }
        return false;
      });
    }
    return {
      handle: metaHandle,
      title: m.title || '',
      tags: (m.tags && m.tags.length ? m.tags : tags) || [],
      portions: m.portions || 0,
      priceCents: m.price || 0,
      unitPriceCents: Number(m.unitPrice) || 0,
      unitRef: m.unitRef || '',
      img2: m.img2 || img2
    };
  }
  function enrichCards(bundle) {
    var pct = discountFor(boxCount());
    /* Glutenfrei lives in the hero copy — keep the spare span empty. */
    var glutenEl = document.querySelector('#rothsteiner-bundle-banner .rothsteiner-bundle-banner__gluten');
    if (glutenEl) {
      glutenEl.hidden = true;
      glutenEl.textContent = '';
    }

    bundle.querySelectorAll('.gbbProductItem[data-product-id]').forEach(function (card) {
      var info = metaFor(card);
      var text = card.querySelector('.gbbProductTextContainer');
      if (!text) return;

      /* Title first, then one meta line (badges + Portionen). */
      var titleEl = text.querySelector('.gbbProductTitleOnly, .gbbProductTitle');
      var badges = text.querySelector('.rs-card-badges');
      if (badges) badges.remove();
      var meta = text.querySelector('.rs-card-meta');
      if (!meta) {
        meta = document.createElement('div');
        meta.className = 'rs-card-meta';
        if (titleEl) titleEl.after(meta); else text.prepend(meta);
      }

      var want = [];
      var tagset = info.tags.map(function (t) { return String(t).toLowerCase(); });
      var titleNorm = norm((info.title || (titleEl && titleEl.textContent) || ''));
      var handleNorm = String(info.handle || '').toLowerCase();
      var forceVegetarian =
        handleNorm.indexOf('bolognese') !== -1 ||
        handleNorm.indexOf('rahmsosse') !== -1 ||
        handleNorm.indexOf('rahmso') !== -1 ||
        titleNorm.indexOf('bolognese') !== -1 ||
        titleNorm.indexOf('rahmso') !== -1;
      if (tagset.some(function (t) { return t === 'bio' || t.indexOf('bio') !== -1; })) want.push('Bio');
      if (tagset.some(function (t) { return t === 'vegan'; })) want.push('Vegan');
      else if (
        forceVegetarian ||
        tagset.some(function (t) { return t === 'vegetarisch' || t.indexOf('vegetar') !== -1; })
      ) {
        want.push('Vegetarisch');
      }
      if (info.portions > 0) want.push(info.portions + ' Portionen');
      var metaHtml = want.length ? '<span class="rs-card-tags">' + want.join(' · ') + '</span>' : '';
      if (meta.dataset.rs !== metaHtml) { meta.dataset.rs = metaHtml; meta.innerHTML = metaHtml; }

      text.querySelectorAll('.rs-card-info').forEach(function (el) { el.remove(); });

      var priceEl = card.querySelector('.gbbProductPrice');
      if (priceEl && info.priceCents > 0) {
        var base = info.priceCents / 100;
        var showDisc = pct > 0;
        var now = showDisc ? discUnit(base, pct) : base;
        var unitBit = unitBesideFromDisplay(info, now);
        var label = (showDisc ? 'd' : 'f') + '|' + money(now) + '|' + money(base) + '|' + unitBit;
        if (priceEl.dataset.rsPrice !== label) {
          priceEl.dataset.rsPrice = label;
          if (showDisc) {
            priceEl.innerHTML =
              '<span class="rs-card-price-row">' +
                '<strong class="rs-card-now">' + money(now) + '</strong>' +
                '<span class="rs-card-was">' + money(base) + '</span>' +
                (unitBit ? '<span class="rs-card-unit-beside">· ' + unitBit + '</span>' : '') +
              '</span>';
          } else {
            priceEl.innerHTML =
              '<span class="rs-card-price-row">' +
                '<strong class="rs-card-now">' + money(base) + '</strong>' +
                (unitBit ? '<span class="rs-card-unit-beside">· ' + unitBit + '</span>' : '') +
              '</span>';
          }
        }
      } else if (priceEl && priceEl.dataset.rsPrice) {
        delete priceEl.dataset.rsPrice;
      }

      var unitWrap = priceEl && priceEl.parentElement && priceEl.parentElement.querySelector('.rs-card-unit-wrap');
      if (unitWrap) unitWrap.remove();

      var imgWrap = card.querySelector('.gbbProductImageContainer');
      var img = imgWrap && imgWrap.querySelector('img.gbbProductImage');
      if (imgWrap && img && info.img2) {
        var dish = imgWrap.querySelector('.rs-card-dish');
        if (!dish) {
          dish = document.createElement('img');
          dish.className = 'rs-card-dish';
          dish.alt = '';
          dish.loading = 'lazy';
          dish.setAttribute('aria-hidden', 'true');
          imgWrap.appendChild(dish);
        }
        if (dish.dataset.rsSrc !== info.img2) {
          dish.dataset.rsSrc = info.img2;
          dish.src = info.img2;
        }
        card.classList.add('rs-has-dish');
      } else {
        card.classList.remove('rs-has-dish');
      }
    });
  }

  /* ---------- empty state / reset / CTA ---------- */
  function ensureEmptyState(bundle) {
    /* Empty copy lives in .rs-contents — hide legacy node if GBB/our older code left one. */
    var empty = bundle.querySelector('.rs-set-empty');
    if (empty) empty.hidden = true;
  }

  function updateCta(bundle) {
    var btn = bundle.querySelector('.gbbFooterNextButton');
    if (!btn) return;
    var state = readSet();
    var empty = state.count === 0;
    bundle.setAttribute('data-rs-empty', empty ? '1' : '0');
    ensureEmptyState(bundle);

    var title = bundle.querySelector('.gbbFooterBundleTitle');
    if (title) {
      var titleLabel = empty ? 'Dein Set' : ('Dein Set (' + products(state.count) + ')');
      if (title.dataset.rsTitle !== titleLabel) {
        title.dataset.rsTitle = titleLabel;
        title.textContent = titleLabel;
      }
    }

    var clear = bundle.querySelector('.gbbFooterClearItemsButtonWrapper');
    if (clear) {
      clear.classList.toggle('rs-clear--hidden', empty);
      var clearTxt = clear.querySelector('.gbbFooterClearItemsContent');
      if (clearTxt) clearTxt.textContent = 'Set zurücksetzen';
    }

    var label = empty ? 'Wähle dein erstes Produkt' : 'Zur Kasse';
    btn.setAttribute('aria-disabled', empty ? 'true' : 'false');
    btn.classList.toggle('rs-cta--disabled', empty);
    if (btn.tagName === 'BUTTON' || btn.tagName === 'INPUT') btn.disabled = empty;

    if (btn.dataset.rsCta !== label) {
    btn.dataset.rsCta = label;
    var leaf = Array.prototype.slice.call(btn.querySelectorAll('*')).reverse().find(function (el) {
      var t = (el.textContent || '').trim();
        return t && !el.children.length && /warenkorb|box|weiter|kasse|set|wähle|produkt|€/i.test(t);
    });
    if (leaf) leaf.textContent = label;
      else if (!btn.querySelector('*')) btn.textContent = label;
    }

    var wrap = bundle.querySelector('.gbbFooterButtonsWrapper');
    if (wrap) {
      wrap.style.setProperty('display', 'flex', 'important');
      wrap.style.setProperty('flex-direction', 'column', 'important');
      wrap.style.setProperty('align-items', 'stretch', 'important');
      wrap.style.setProperty('grid-template-columns', 'none', 'important');
      wrap.style.setProperty('width', '100%', 'important');
      btn.style.setProperty('width', '100%', 'important');
      var trust = wrap.querySelector('.rs-cta-trust');
      if (!trust) {
        trust = document.createElement('div');
        trust.className = 'rs-cta-trust';
        trust.innerHTML = '<div>Kein Abo · Lieferung in 2–5 Werktagen</div><div class="rs-cta-trust__row" data-rs-pay></div>';
        wrap.appendChild(trust);
      }
      var payRow = trust.querySelector('[data-rs-pay]');
      if (payRow && (!payRow.dataset.rsReady || !payRow.querySelector('svg'))) {
        var payHtml = (window.RS_SET_PAY_HTML || '').trim();
        if (payHtml) {
          payRow.innerHTML = payHtml;
          payRow.dataset.rsReady = '1';
        }
      }
      var line = trust.querySelector('div:not([data-rs-pay]):not(.rs-cta-trust__row)');
      if (line) {
        line.textContent = 'Kein Abo · Lieferung in 2–5 Werktagen';
      }
    }

    var totalItems = bundle.querySelector('.gbbFooterTotalItemsInCart');
    if (totalItems) {
      var wantItems = empty ? '' : (state.count + ' Artikel');
      if (totalItems.dataset.rs !== wantItems) {
        totalItems.dataset.rs = wantItems;
        totalItems.textContent = wantItems;
      }
    }

    syncHeaderCartBadge(state.count);
  }

  function syncHeaderCartBadge(packageCount) {
    var bubbles = document.querySelectorAll('.cart-count-bubble, #cart-icon-bubble .cart-count-bubble, [data-cart-count]');
    if (!bubbles.length) return;
    if (packageCount > 0) {
      bubbles.forEach(function (el) {
        var leaf = el.querySelector('span') || el;
        el.dataset.rsPkg = '1';
        leaf.textContent = String(packageCount);
      });
      return;
    }
    var owned = Array.prototype.some.call(bubbles, function (el) { return el.dataset.rsPkg === '1'; });
    if (!owned) return;
    bubbles.forEach(function (el) { delete el.dataset.rsPkg; });
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = Number(cart && cart.item_count) || 0;
        bubbles.forEach(function (el) {
          if (el.dataset.rsPkg === '1') return;
          var leaf = el.querySelector('span') || el;
          leaf.textContent = n > 0 ? String(n) : '';
        });
      })
      .catch(function () {});
  }

  /* ---------- carousel first-arrow ---------- */
  function updateCarousel() {
    document.querySelectorAll('.gbbModal[data-status="opened"] .gbbProductVariantModalContainer').forEach(function (modal) {
      modal.querySelectorAll('.gbbCarouselSlide img').forEach(function (img) {
        var lazy = img.getAttribute('data-src') || img.getAttribute('data-original') || img.getAttribute('data-lazy');
        if (lazy && (!img.getAttribute('src') || img.getAttribute('src').indexOf('data:') === 0)) {
          img.setAttribute('src', lazy);
        }
        img.loading = 'eager';
      });
      var main = modal.querySelector('.gbbCarouselMain');
      if (!main) return;
      var slides = Array.prototype.slice.call(main.querySelectorAll('.gbbCarouselSlide'));
      if (!slides.length) return;
      var index = Math.max(0, slides.findIndex(function (s) { return !s.classList.contains('gbbHidden'); }));
      var prev = main.querySelector('.gbbCarouselPrev');
      if (prev) {
        var disable = index <= 0;
        prev.style.opacity = disable ? '0.25' : '1';
        prev.style.pointerEvents = disable ? 'none' : 'auto';
        prev.setAttribute('aria-disabled', disable ? 'true' : 'false');
      }
    });
  }

  /* ---------- popup suppress ---------- */
  function killPopup() {
    document.querySelectorAll('.klaviyo-form, [class*="kl-private-reset"], .needsclick.kl-teaser, iframe[title*="Klaviyo" i]').forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
    });
  }

  /* ---------- single debounced run ---------- */
  var queued = false;
  function paint() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      var bundle = document.getElementById('gbbBundle');
      if (!bundle) return;
      patchClearLanguage();
      teardownAllPage(bundle);
      enrichFooterPrices(bundle);
      renderProgress(bundle);
      enrichCards(bundle);
      updateCta(bundle);
      syncSummary(bundle);
      killPopup();
      /* Beat the shipping-summary liquid that re-parses enriched prices. */
      setTimeout(function () { syncSummary(bundle); }, 0);
      setTimeout(function () { syncSummary(bundle); }, 50);
    });
  }

  /* Use click (not pointerdown): pending styles must not run before GBB receives the click. */
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest && e.target.closest(
      '#gbbBundle .gbbProductAddButton, #gbbBundle .gbbQuantityStepperAddButton'
    );
    if (!addBtn || addBtn.getAttribute('aria-busy') === 'true') return;
    addBtn.classList.add('rs-add--pending');
    addBtn.setAttribute('aria-busy', 'true');
    var label = addBtn.querySelector('span, .gbbProductAddButtonText') || addBtn;
    if (!addBtn.dataset.rsAddLabel) addBtn.dataset.rsAddLabel = (label.textContent || '').trim();
    if (/zum set|zur box|\+|add/i.test(addBtn.dataset.rsAddLabel || addBtn.textContent || '')) {
      try { label.textContent = '…'; } catch (err) {}
    }
    window.setTimeout(function () {
      addBtn.classList.remove('rs-add--pending');
      addBtn.removeAttribute('aria-busy');
      if (addBtn.dataset.rsAddLabel) {
        try { label.textContent = addBtn.dataset.rsAddLabel; } catch (err2) {}
      }
    }, 700);
  }, true);

  document.addEventListener('click', function (e) {
    var atc = e.target.closest && e.target.closest('#gbbBundle .gbbFooterNextButton');
    if (atc && (atc.getAttribute('aria-disabled') === 'true' || atc.classList.contains('rs-cta--disabled'))) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    /* One open path for image / title / details — stops GBB same-click backdrop close. */
    var openHit = e.target.closest && e.target.closest(
      '#gbbBundle .rs-card-info, #gbbBundle .gbbProductOverlay, #gbbBundle .gbbProductImage, #gbbBundle .gbbProductTitleOnly, #gbbBundle .gbbProductTitle'
    );
    if (
      openHit &&
      !e.target.closest('.gbbProductAddButton, .gbbQuantityStepperAddButton, .gbbQuantityStepper, .gbbProductActionContainer')
    ) {
      var openCard = openHit.closest('.gbbProductItem');
      if (openCard) {
        e.preventDefault();
        e.stopImmediatePropagation();
        openProductDetails(openCard);
      return;
      }
    }
    var chip = e.target.closest && e.target.closest('.rs-progress__chip[data-product-id]');
    if (chip) {
      e.preventDefault();
      var card = document.querySelector('#gbbBundle .gbbProductItem[data-product-id="' + chip.getAttribute('data-product-id') + '"]');
      var add = card && card.querySelector('.gbbProductAddButton, .gbbQuantityStepperAddButton');
      if (add) add.click();
      return;
    }
    var presetBtn = e.target.closest && e.target.closest('.rs-progress__preset[data-tier-n]');
    if (presetBtn) {
      e.preventDefault();
      var n = parseInt(presetBtn.getAttribute('data-tier-n'), 10);
      if (n) fillHandles(BESTSELLERS.slice(0, n));
      return;
    }
    var arrow = e.target.closest && e.target.closest('.gbbCarouselPrev, .gbbCarouselNext');
    if (arrow) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var main = arrow.closest('.gbbCarouselMain');
      stepCarousel(main, arrow.classList.contains('gbbCarouselNext') ? 1 : -1);
    }
  }, true);

  function ensureBootOverlay() {
    document.documentElement.classList.add('rs-set-page', 'rs-set-booting');
    /* Prefer liquid-injected #rs-set-boot so it paints before GBB's spinner. */
    if (document.getElementById('rs-set-boot')) return;
    var el = document.createElement('div');
    el.id = 'rs-set-boot';
    el.className = 'rs-set-boot';
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('aria-busy', 'true');
    var logoUrl = window.RS_SET_BOOT_LOGO || '';
    var shopName = window.RS_SET_BOOT_NAME || 'Rothsteiner';
    var brandHtml = logoUrl
      ? '<img src="' + logoUrl + '" alt="' + String(shopName).replace(/"/g, '&quot;') + '" width="280" height="88">'
      : '<span>' + String(shopName).replace(/</g, '&lt;') + '</span>';
    el.innerHTML =
      '<div class="rs-set-boot__card">' +
        '<div class="rs-set-boot__brand">' + brandHtml + '</div>' +
        '<div class="rs-set-boot__bar" aria-hidden="true"><i></i></div>' +
        '<p class="rs-set-boot__title">Dein Set wird vorbereitet</p>' +
        '<p class="rs-set-boot__sub">Produkte &amp; Rabatte laden…</p>' +
      '</div>';
    (document.body || document.documentElement).appendChild(el);
  }

  function preloadUrl(url) {
    return new Promise(function (resolve) {
      if (!url) { resolve(false); return; }
      var img = new Image();
      var done = function () { resolve(true); };
      img.onload = done;
      img.onerror = done;
      img.src = url;
      setTimeout(done, 2500);
    });
  }

  function collectPreloadUrls() {
    var urls = {};
    Object.keys(META).forEach(function (handle) {
      var m = META[handle] || {};
      if (m.image) urls[m.image] = 1;
      if (m.img2) urls[m.img2] = 1;
      (m.images || []).forEach(function (u) { if (u) urls[u] = 1; });
    });
    document.querySelectorAll('#gbbBundle .gbbProductImage[src]').forEach(function (img) {
      if (img.src) urls[img.src] = 1;
    });
    return Object.keys(urls);
  }

  function warmPopupMeta() {
    try {
      if (typeof window.RSPopupRefresh === 'function') window.RSPopupRefresh();
    } catch (e) {}
    try {
      if (window.RS_SET_META && !window.RS_SET_META_BY_ID) {
        /* popup script builds indexes on start — nudge a prepare on first product */
        var first = Object.keys(META)[0];
        if (first && META[first] && typeof window.RSPopupPrepare === 'function') {
          window.RSPopupPrepare(META[first].id, META[first].title);
        }
      }
    } catch (e2) {}
  }

  function finishBoot() {
    if (window.__rsSetReady) return;
    window.__rsSetReady = true;
    document.documentElement.classList.add('rs-set-ready');
    var boot = document.getElementById('rs-set-boot');
    if (boot) {
      boot.classList.add('rs-set-boot--done');
      boot.setAttribute('aria-busy', 'false');
    }
    requestAnimationFrame(function () {
      document.documentElement.classList.remove('rs-set-booting');
      paint();
      setTimeout(function () {
        if (boot && boot.parentNode) boot.parentNode.removeChild(boot);
      }, 480);
    });
  }

  function runBoot() {
    ensureBootOverlay();
    var started = Date.now();
    var minMs = 1600;
    var settleMs = 450;
    var maxMs = 12000;

    /* Hard safety net: guarantees the overlay is dismissed even if tick()'s
       ready-path throws before finishBoot() is reached. finishBoot() itself
       is idempotent (guarded by window.__rsSetReady), so this never double-fires. */
    setTimeout(finishBoot, maxMs + settleMs);

    function cardsReady() {
      var bundle = document.getElementById('gbbBundle');
      if (!bundle) return false;
      return bundle.querySelectorAll('.gbbProductItem[data-product-id]').length >= 4;
    }

    function gbbReady() {
      try {
        return Boolean(window.gbb && gbb.components && gbb.components.productCard);
      } catch (e) {
        return false;
      }
    }

    function tick() {
      if (Date.now() - started > maxMs) {
        finishBoot();
      return;
    }
      if (!cardsReady() || !gbbReady()) {
        setTimeout(tick, 100);
        return;
      }
      try {
        paint();
        warmPopupMeta();
        var urls = collectPreloadUrls().slice(0, 40);
        var waitMin = Math.max(0, minMs - (Date.now() - started));
        Promise.all(urls.map(preloadUrl)).then(function () {
          setTimeout(finishBoot, waitMin + settleMs);
        });
      } catch (e) {
        finishBoot();
      }
    }
    tick();
  }

  function start() {
    ensureBootOverlay();
    var staleDrawer = document.getElementById('rs-set-drawer');
    if (staleDrawer && staleDrawer.parentNode) staleDrawer.parentNode.removeChild(staleDrawer);
    document.documentElement.classList.remove('rs-drawer-open');
    var early = document.getElementById('gbbBundle');
    if (early) teardownAllPage(early);
    paint();
    watchPopupLayout();
    var target = document.getElementById('gbbBundle') || document.body;
    new MutationObserver(paint).observe(target, {
      childList: true,
      subtree: true,
      attributes: true,
      /* No "class" — GBB toggles slide classes in the popup and that re-entry crashed tabs. */
      attributeFilter: ['data-value', 'data-cart-items-length', 'data-is-active']
    });
    var bootPoll = setInterval(function () {
      var b = document.getElementById('gbbBundle');
      if (!b) return;
      clearInterval(bootPoll);
      paint();
      new MutationObserver(paint).observe(b, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-value', 'data-cart-items-length', 'data-is-active']
      });
    }, 200);
    runBoot();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
